import { useTranslation } from "react-i18next";
import { LOGO_CIVISOFT, LOGO_GEO5 } from "../constants";

export default function AccesExpire({ onDeconnexion }) {
  const { t } = useTranslation();
  const GV = {
    vert:"#2D7A2D", vertClair:"#00A651",
    dark:"#1A1A1A", grisMid:"#6B7280", blanc:"#FFFFFF",
    rouge:"#DC2626", rougeLight:"#FEF2F2",
  };

  return (
    <div style={{ minHeight:"100vh", background:"linear-gradient(160deg,#fff5f5 0%,#fee2e2 50%,#fecaca 100%)", display:"flex", alignItems:"center", justifyContent:"center", padding:24, fontFamily:"'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ width:"100%", maxWidth:500, textAlign:"center" }}>

        {/* Logos */}
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:40 }}>
          {LOGO_CIVISOFT && <img src={LOGO_CIVISOFT} alt="CiviSoft" style={{ height:44, objectFit:"contain" }}/>}
          {LOGO_GEO5     && <img src={LOGO_GEO5}     alt="GEO5"     style={{ height:34, objectFit:"contain" }}/>}
        </div>

        {/* Carte */}
        <div style={{ background:GV.blanc, borderRadius:20, boxShadow:"0 8px 40px rgba(220,38,38,0.15)", overflow:"hidden" }}>

          {/* Bandeau rouge */}
          <div style={{ background:"linear-gradient(135deg,#DC2626,#EF4444)", padding:"28px 32px" }}>
            <div style={{ fontSize:48, marginBottom:12 }}>⏰</div>
            <div style={{ fontSize:22, fontWeight:900, color:GV.blanc, marginBottom:6 }}>{t("acces_expire.titre")}</div>
            <div style={{ fontSize:13, color:"rgba(255,255,255,0.85)" }}>{t("acces_expire.sous_titre")}</div>
          </div>

          {/* Corps */}
          <div style={{ padding:"32px" }}>
            <p style={{ fontSize:14, color:GV.dark, lineHeight:1.8, marginBottom:24 }}>
              {t("acces_expire.corps")}
            </p>

            {/* Bloc contact */}
            <div style={{ background:"#F0FDF4", border:"1.5px solid #2D7A2D", borderRadius:12, padding:"20px 24px", marginBottom:24, textAlign:"left" }}>
              <div style={{ fontSize:13, fontWeight:800, color:GV.vert, marginBottom:12 }}>{t("acces_expire.contact_titre")}</div>
              <div style={{ fontSize:13, color:GV.dark, lineHeight:2 }}>
                🌐 <a href="https://civisoft.fr" target="_blank" rel="noreferrer" style={{ color:GV.vert, fontWeight:700 }}>civisoft.fr</a><br/>
                ✉️ <strong>contact@civisoft.fr</strong><br/>
                🏢 {t("acces_expire.exclusif")}
              </div>
            </div>

            <div style={{ fontSize:12, color:GV.grisMid, marginBottom:24, background:"#F9FAFB", borderRadius:8, padding:"10px 14px" }}>
              {t("acces_expire.conseil")}
            </div>

            <button onClick={onDeconnexion}
              style={{ width:"100%", padding:"12px", background:`linear-gradient(135deg,${GV.vert},${GV.vertClair})`, border:"none", borderRadius:10, fontSize:14, fontWeight:700, color:GV.blanc, cursor:"pointer", boxShadow:`0 4px 16px ${GV.vert}30` }}>
              {t("acces_expire.retour")}
            </button>
          </div>
        </div>

        <div style={{ marginTop:20, fontSize:11, color:"#9CA3AF" }}>
          {t("acces_expire.copyright")}
        </div>
      </div>
    </div>
  );
}
